module.exports = __webpack_public_path__ + "fontawesome-webfont.25a32416abee198dd821.eot";


//////////////////
// WEBPACK FOOTER
// ./~/components-font-awesome/fonts/fontawesome-webfont.eot
// module id = 231
// module chunks = 2